/* ═══════════════════════════════════════════════════════════
   pf-unified-cards.js  v2
   Enhances collection & search product cards:
   - Adds colored stock-status dots
   - Manages sticky sidebar offset
   (View toggle handled by theme's existing buttons)
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var page = document.querySelector('.template-collection') || document.querySelector('.template-search');
  if (!page) return;

  /* ══════════════════════════════════════
     1. STOCK STATUS DOTS
     ══════════════════════════════════════ */

  function enhanceStockStatus(scope) {
    var root = scope || page;
    root.querySelectorAll('.stock_status_wrap').forEach(function (wrap) {
      if (wrap.dataset.pfuEnhanced) return;
      wrap.dataset.pfuEnhanced = '1';

      var text = wrap.textContent.trim().toLowerCase();
      var status = '';
      if (text.indexOf('på lager') !== -1 || text.indexOf('in stock') !== -1) {
        status = 'in';
      } else if (text.indexOf('forventet') !== -1 || text.indexOf('expected') !== -1 || text.indexOf('dager') !== -1) {
        status = 'expected';
      } else if (text.indexOf('ikke') !== -1 || text.indexOf('out') !== -1 || text.indexOf('utsolgt') !== -1) {
        status = 'out';
      }

      if (status) wrap.classList.add('stock_status_wrap--' + status);

      var icon = wrap.querySelector('.badge-stock-icon');
      if (icon) icon.classList.add('pfu-stock-dot');
    });

    root.querySelectorAll('.badge-stock').forEach(function (wrap) {
      if (wrap.dataset.pfuEnhanced) return;
      wrap.dataset.pfuEnhanced = '1';
      var icon = wrap.querySelector('.badge-stock-icon');
      if (icon) icon.classList.add('pfu-stock-dot');
    });
  }

  /* ══════════════════════════════════════
     2. STICKY SIDEBAR OFFSET
     ══════════════════════════════════════ */

  function updateSidebarTop() {
    var header = document.querySelector('header, .header, .shopify-section-header, #shopify-section-header');
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--pf-sidebar-top', (h + 20) + 'px');
  }

  /* ══════════════════════════════════════
     3. MUTATION OBSERVER
     ══════════════════════════════════════ */

  function observeProductGrid() {
    var grid = page.querySelector('#product-grid');
    if (!grid) return;

    var observer = new MutationObserver(function () {
      enhanceStockStatus(grid);
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  /* ══════════════════════════════════════
     4. MOBILE FILTER DRAWER OPEN/CLOSE
     (Collection & Search page)
     ══════════════════════════════════════ */

  function bindFilterDrawer() {
    var sidebar = page.querySelector('.filters_side_bar_custom');
    if (!sidebar) return;

    function openDrawer() {
      sidebar.classList.add('opened');
      document.body.classList.add('page-layout-sidebar-drawer-open');
      document.body.classList.add('overflow-hidden-tablet');
    }

    function closeDrawer() {
      sidebar.classList.remove('opened');
      document.body.classList.remove('page-layout-sidebar-drawer-open');
      document.body.classList.remove('overflow-hidden-tablet');
    }

    /* Delegated click handler */
    document.addEventListener('click', function (event) {
      var target = event.target;

      /* OPEN: filter-button */
      var openBtn = target.closest('.button-sidebar-drawer-open');
      if (openBtn) {
        event.preventDefault();
        openDrawer();
        return;
      }

      /* CLOSE: X, Søk, eller hvilken som helst dismiss-knapp */
      var dismissBtn = target.closest('.js-button-sidebar-drawer-dismiss');
      if (dismissBtn) {
        closeDrawer();
        return;
      }

      /* CLOSE: klikk utenfor drawer (på overlay) */
      if (sidebar.classList.contains('opened') &&
          !target.closest('.filters_side_bar_custom') &&
          !target.closest('.button-sidebar-drawer-open')) {
        closeDrawer();
      }
    });

    /* CLOSE: ESC-tast */
    document.addEventListener('keyup', function (event) {
      if ((event.key === 'Escape' || event.code === 'Escape') &&
          sidebar.classList.contains('opened')) {
        closeDrawer();
      }
    });
  }

  /* ══════════════════════════════════════
     INIT
     ══════════════════════════════════════ */

  function init() {
    enhanceStockStatus();
    updateSidebarTop();
    observeProductGrid();
    bindFilterDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', updateSidebarTop, { passive: true });
  window.addEventListener('scroll', function () {
    requestAnimationFrame(updateSidebarTop);
  }, { passive: true, once: true });

})();